import { THEME_MODE } from "../actions/constants";

const initialState = {
  // Light is the application default. Only an explicit saved "dark"
  // preference should enable dark mode.
  themeMode: localStorage.getItem("themeMode") === "dark",
};

export default function themeReducer(state = initialState, action) {
  switch (action.type) {
    case THEME_MODE:
      return {
        ...state,
        themeMode: action.payload,
      };
    default:
      return state;
  }
}
